/**
 * Projects Module Routes Configuration
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Layout from '../../../../components/Layout';
import PrivateRoute from '../../../../components/PrivateRoute';

// Pages
import Dashboard from '../pages/Dashboard';
import ProjectManagement from '../pages/ProjectManagement';
import FormBuilder from '../pages/FormBuilder';
import WorkflowBuilder from '../pages/WorkflowBuilder';

/**
 * Projects route configuration
 */
export const projectsRoutes: RouteObject[] = [
  {
    path: '/app/projects',
    element: <PrivateRoute><Layout /></PrivateRoute>,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'management',
        element: <ProjectManagement />
      },
      {
        path: 'form-builder',
        element: <FormBuilder />
      },
      {
        path: 'workflow-builder',
        element: <WorkflowBuilder />
      }
    ]
  }
];

export default projectsRoutes;
